import * as Tone from 'tone';
import { PlaybackMode } from './Simpler';
var VoiceType;
(function (VoiceType) {
    VoiceType[VoiceType["NORMAL"] = 0] = "NORMAL";
    VoiceType[VoiceType["ONESHOT"] = 1] = "ONESHOT";
    VoiceType[VoiceType["FADE"] = 2] = "FADE";
})(VoiceType || (VoiceType = {}));
class SimplerVoice {
    constructor(parent) {
        this.bufferSourceNode = null;
        this.voiceType = VoiceType.NORMAL;
        this.buffer = undefined;
        this.simpler = parent;
        this.envelope = new Tone.AmplitudeEnvelope({
            attack: parent.attack,
            decay: parent.decay,
            sustain: parent.sustain,
            // Ableton's release does not sound the same as the Web Audio release curve.
            // We will reduce the release time so it sounds more like Ableton
            release: parent.release * 0.77,
            releaseCurve: 'exponential'
        });
        this.envelope.connect(this.simpler.output());
    }
    start(audioContextTime, velocity, playbackRate, playbackMode) {
        this.buffer = this.simpler.buffer.get();
        if (playbackMode === PlaybackMode.CLASSIC) {
            if (this.simpler.loop && this.simpler.loopFade > 0) {
                this.simpler.constructFadeLoopBufferIfNecessary();
                this.startFadeVoice(audioContextTime, velocity, playbackRate);
            }
            else {
                const loopPoints = this.simpler.calculateLoopPoints();
                this.startNormalVoice(audioContextTime, velocity, playbackRate, loopPoints.startTime, loopPoints.loopStart, loopPoints.loopEnd);
            }
        }
        else if (playbackMode === PlaybackMode.ONESHOT) {
            this.startOneShot(audioContextTime, velocity, playbackRate);
        }
    }
    stop(audioContextTime) {
        if (this.voiceType === VoiceType.NORMAL ||
            this.voiceType === VoiceType.FADE) {
            this.envelope.triggerRelease(audioContextTime);
            const stopTime = audioContextTime + this.simpler.release;
            this.bufferSourceNode.stop(stopTime);
        }
    }
    startFadeVoice(audioContextTime, velocity, playbackRate) {
        this.voiceType = VoiceType.FADE;
        this.bufferSourceNode = Tone.context.createBufferSource();
        this.bufferSourceNode.onended = this.dispose.bind(this);
        this.bufferSourceNode.buffer = this.simpler.fadeLoopBuffer;
        this.bufferSourceNode.playbackRate.value = playbackRate;
        this.envelope.triggerAttack(audioContextTime, velocity);
        Tone.connect(this.bufferSourceNode, this.envelope);
        this.bufferSourceNode.loop = true;
        this.bufferSourceNode.loopStart = this.simpler.fadeLoopBufferLoopStart;
        this.bufferSourceNode.loopEnd = this.simpler.fadeLoopBufferLoopEnd;
        this.bufferSourceNode.start(audioContextTime);
    }
    startNormalVoice(audioContextTime, velocity, playbackRate, startTime, loopStart, loopEnd) {
        this.voiceType = VoiceType.NORMAL;
        this.bufferSourceNode = Tone.context.createBufferSource();
        this.bufferSourceNode.onended = this.dispose.bind(this);
        this.bufferSourceNode.buffer = this.buffer;
        this.bufferSourceNode.playbackRate.value = playbackRate;
        this.envelope.triggerAttack(audioContextTime, velocity);
        Tone.connect(this.bufferSourceNode, this.envelope);
        if (this.simpler.loop) {
            this.bufferSourceNode.loop = true;
            this.bufferSourceNode.loopStart = loopStart;
            this.bufferSourceNode.loopEnd = loopEnd;
            this.bufferSourceNode.start(audioContextTime, startTime);
        }
        else {
            this.bufferSourceNode.start(audioContextTime, startTime, loopEnd);
        }
    }
    startOneShot(audioContextTime, velocity, playbackRate) {
        this.voiceType = VoiceType.ONESHOT;
        this.bufferSourceNode = Tone.context.createBufferSource();
        this.bufferSourceNode.onended = this.dispose.bind(this);
        this.bufferSourceNode.buffer = this.buffer;
        this.envelope.attack = this.simpler.fadeInTime;
        this.envelope.sustain = 1;
        this.envelope.release = this.simpler.fadeOutTime + 0.00001;
        this.bufferSourceNode.playbackRate.value = playbackRate;
        Tone.connect(this.bufferSourceNode, this.envelope);
        this.bufferSourceNode.loop = false;
        const duration = this.buffer.duration * playbackRate - this.envelope.release;
        this.envelope.triggerAttackRelease(duration, audioContextTime, velocity);
        this.bufferSourceNode.start(audioContextTime);
    }
    dispose() {
        this.bufferSourceNode.disconnect();
        this.bufferSourceNode = null;
        this.envelope.dispose();
    }
}
export default SimplerVoice;
//# sourceMappingURL=SimplerVoice.js.map